import { authorizeMe, axiosInstance } from "./commonHeadApiLogic";

const withAuthorization = async (apiFunction, ...args) => {
    try {
        await authorizeMe();
        return await apiFunction(...args);
    } catch (error) {
        console.error("Error in API request:", error);
        throw error;
    }
};

export async function getChatMessages(bookingId, params) {
    return withAuthorization(async () => {
        // params can include page, limit
        return await axiosInstance.get(`/api/chat/messages/${bookingId}`, { params });
    });
}

export async function getUserConversations() {
    return withAuthorization(async () => {
        return await axiosInstance.get("/api/chat/conversations");
    });
}

export async function createChatConversation(quoteId) {
    return withAuthorization(async () => {
        return await axiosInstance.post("/api/chat/create-conversation", { quoteId });
    });
}

export async function sendMessageApi(quoteId, message, type = "text") {
    return withAuthorization(async () => {
        return await axiosInstance.post("/api/chat/send-message", { quoteId, message, type });
    });
}

export async function sendQuoteSummaryMessage(quoteId, summaryPayload) {
    return withAuthorization(async () => {
        const formData = summaryPayload?.formData || {};
        return axiosInstance.post("/api/chat/send-message", {
            quoteId,
            type: "quoteSummary",
            messageType: "quoteSummary",
            message: JSON.stringify(summaryPayload),
            eventType: summaryPayload?.eventType,
            clientName: formData.name,
            budget: formData.budget,
            city: formData.city,
            location: formData.city,
            startDate: formData.date,
            requirements: formData.coverage ? [formData.coverage] : undefined,
            editingPreferences:
                formData.editing === "Yes"
                    ? true
                    : formData.editing === "No"
                    ? false
                    : undefined,
        });
    });
}


export async function postConvertQuoteIntoBooking(quoteId, payload) {
  return withAuthorization(async () => {
    return axiosInstance.post(
      `api/users/quotes/convertToBooking/${quoteId}`,
      payload
    );
  });
}


// RejectQuote

export async function rejectQuoteAPI(messageId, payload) {
  return withAuthorization(async () => {
    return axiosInstance.put(
      `/api/chat/reject-qutation/${messageId}`,
      payload
    );
  });
}